// noinspection JSUnusedGlobalSymbols
import axios from "axios";
const COOKIE_NAME_PREFIX = 'siser[' + process.env.ENVIRONMENT + ']';
export const SITE_ALERT_TYPE_ERROR = 'error';
export const SITE_ALERT_TYPE_INFO = 'info';
export const SITE_ALERT_TYPE_SUCCESS = 'success';
export const SITE_ALERT_TYPE_WARN = 'warn';

// noinspection JSUnusedGlobalSymbols
export const SITE_ALERT_TYPES = {
  [SITE_ALERT_TYPE_SUCCESS]: {
    "name": "Success",
    "description": "A message about a positive action."
  },
  [SITE_ALERT_TYPE_INFO]: {
    "name": "Info",
    "description": "Informational update. Usually a neutral or somewhat positive message in tone."
  },
  [SITE_ALERT_TYPE_WARN]: {
    "name": "Warning",
    "description": "Alerting the user about a potentially negative or critical event. This could be emergency site maintenance, for example."
  },
  [SITE_ALERT_TYPE_ERROR]: {
    "name": "Error",
    "description": "Extremely critical alert. Should be used sparingly."
  }
};
export const SITE_ACCOUNT = 'account';
export const SITE_AUTH = 'auth';
export const SITE_LEONARDO_DESIGN_STUDIO = 'lds';
export const SITE_SETUP = 'setup';

// noinspection JSUnusedGlobalSymbols
export const SITES_DIRECTORY = {
  [SITE_ACCOUNT]: {
    "description": "Account management area for users and employees",
    "name": "Siser Account Management"
  },
  [SITE_AUTH]: {
    "description": "Site for Siser user authentication and creating an account",
    "name": "Siser Auth"
  },
  [SITE_LEONARDO_DESIGN_STUDIO]: {
    "description": "Web tabs component of the Leonardo Design Studio software",
    "name": "Leonardo Design Studio"
  },
  [SITE_SETUP]: {
    "description": "Site for registration of Siser products",
    "name": "Siser Product Setup"
  }
};
export function addQueryStringValueToUrl(urlString, key, value) {
  let url = new URL(urlString);
  let params = new URLSearchParams(url.search);
  params.append(key, value);
  url.search = params.toString();
  return url.toString();
}
export function cleanErrorMessage(err) {
  if (err.code === "InvalidParameterException") {
    if (err.message.indexOf('username') !== -1 || err.message.indexOf('userAlias') !== -1 || err.message.indexOf('userName') !== -1) {
      return '\'username\' value must not contain spaces';
    }
  }
  return err.message;
}
export function extractErrorMessageFromAxiosCaughtError(err) {
  let msg;
  if (axios.isAxiosError(err)) {
    if (typeof err['response'] !== 'undefined' && typeof err['response']['data'] === 'object' && typeof err['response']['data']['errorMessage'] !== 'undefined') {
      err.message += ' : ' + err['response']['data']['errorMessage'];
    }
    msg = err.message;
  } else {
    msg = 'An unknown error occurred fetching token packs.';
  }
  return msg;
}

// noinspection JSUnusedGlobalSymbols
/**
 * Downloads a file locally that may need special headers sent to an API to retrieve
 */
export function downloadFile(url, headers, filename, document) {
  axios.get(url, {
    headers: headers,
    responseType: 'blob'
  }).then(response => {
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });
}
export function getCookie(cname) {
  if (typeof document === 'undefined' || typeof document.cookie === 'undefined') {
    return false;
  }
  let name = COOKIE_NAME_PREFIX + '[' + cname + "]=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
export function QueryStringGetter() {
  // since we can't build with the window object, we'll define a placeholder function
  let useQuery;
  useQuery = () => new URLSearchParams();
  if (typeof window !== 'undefined') {
    useQuery = () => new URLSearchParams(window.location.search);
  }
  return useQuery;
}
export function sessionStorageExists() {
  return typeof window !== 'undefined' && typeof window['sessionStorage'] !== 'undefined';
}
export function setCookie(cname, cvalue, exdays) {
  if (typeof document === 'undefined' || typeof document.cookie === 'undefined') {
    console.log('no such object as "document" or "cookie"');
    return false;
  }
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = COOKIE_NAME_PREFIX + '[' + cname + ']' + "=" + cvalue + ";" + expires + ";Domain=siser.com";
}
export function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}